export class EnjoyedYear {
  id!: number;
  name!: string;
}
